module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 1
// module chunks = 8